import React from 'react';
import PropTypes from 'prop-types';

import close from '../../assets/icons/Icon-Close.svg';
import "./HighlightPlayerModal.scss";

const HighlightPlayerModal = ({ highlight, onClose }) => {
  const { title } = highlight;

  return (
    <div className="highlight-player-modal" data-testid="highlight-player-modal">
      <div className="highlight-player-modal__header">
        <div className="highlight-player-modal__header__title">
          <span className="highlight-player-modal__header__title__hashtag">#</span>
          <span>{title}</span>
        </div>
        <button onClick={onClose} data-testid="close-button">
          <img src={close} style={{ height: "20px", width: "20px" }}/>
        </button>
      </div>
      <video
        className="highlight-player-modal__video"
        controls={["PlayPause", "Seek"]}
        src={highlight.streamUri}
        poster={highlight.thumbnailUri}
        autoPlay
        loop
      />
    </div>
  );
};

HighlightPlayerModal.propTypes = {
  highlight: PropTypes.object, 
  onClose: PropTypes.func
};

HighlightPlayerModal.defaultProps = {
  highlight: {}, 
  onClose: ()=> {}
};

export default HighlightPlayerModal;